import React, {useReducer} from 'react';
import {Application} from '../../backend/interfaces/application';
import {Reminder} from '../../backend/interfaces/reminder';
import {UserPublicInfo} from '../../backend/responses/user-public-info';
import {AuxiliaryDataCacheContext} from './context';
import {AuxiliaryDataCacheContextActionType, AuxiliaryDataCacheContextState} from './types';
import reducer from './reducer';

// Set Initial State
const initialState: AuxiliaryDataCacheContextState = {
  applications: {},
  reminders: {},
  users: {},
};

export const AuxiliaryDataCacheContextProvider = (props: {children: React.ReactNode}) => {
  // Create Reducer
  const [state, dispatch] = useReducer(reducer, initialState);

  // Set applications
  const setApplications = (applications: {[id: string]: Application}) => {
    // Update
    dispatch({
      type: AuxiliaryDataCacheContextActionType.SET_APPLICATIONS,
      applications: applications,
    });
  };

  // Set reminders
  const setReminders = (reminders: {[id: string]: Reminder}) => {
    // Update
    dispatch({
      type: AuxiliaryDataCacheContextActionType.SET_REMINDERS,
      reminders: reminders,
    });
  };

  // Set users
  const setUsers = (users: {[id: string]: UserPublicInfo}) => {
    // Update
    dispatch({
      type: AuxiliaryDataCacheContextActionType.SET_USERS,
      users: users,
    });
  };

  // Clear all from cache
  const clearAll = () => {
    // Update
    dispatch({
      type: AuxiliaryDataCacheContextActionType.CLEAR_ALL,
    });
  };

  return (
    <AuxiliaryDataCacheContext.Provider
      value={{
        state,
        // Methods
        setApplications,
        setReminders,
        setUsers,
        clearAll,
      }}
    >
      {props.children}
    </AuxiliaryDataCacheContext.Provider>
  );
};
